<template>
	<div class="userBox">
		<div class="login-left">
			<img :src="baseInfo.login_logo" class="login-logo" width="60" height="60" />
			<div class="login-title">
				<p class="yx-color-text-primary yx-pingfang-semibold" style="font-size: 36px">{{ baseInfo.company_name }}</p>
				<p class="yx-color-text-regular fz-24">让团长生意更好做</p>
			</div>
		</div>
		<!--账户密码登录 start-->
		<div class="login-right">
			<div class="yx-background-white p-24 radius-8">
				<h1 class="fz-24 yx-pingfang-Medium">注册</h1>
				<div class="mt-32">
					<div :class="error.teamName ? 'error' : ''">
						<el-input type="text" placeholder="请输入团队名称" size="medium" maxlength="11" v-model.trim="settingInfo.teamName" clearable>
							<i class="i-company" slot="prefix"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.teamName }}</p>
						</div>
					</div>
					<div :class="error.userName ? 'error' : ''">
						<el-input type="text" placeholder="请输入联系人名称" size="medium" v-model.trim="settingInfo.userName" clearable>
							<i class="i-user" slot="prefix"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.userName }}</p>
						</div>
					</div>
					<div :class="error.mobile ? 'error' : ''">
						<el-input type="text" placeholder="请输入11位手机号" size="medium" maxlength="11" v-model="settingInfo.mobile" clearable>
							<i class="i-mobile" slot="prefix"></i>
						</el-input>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.mobile }}</p>
						</div>
					</div>
					<div :class="error.smsCode ? 'error' : ''">
						<div class="flex-row">
							<span class="special">
								<el-input type="text" placeholder="请输入验证码" size="medium" v-model="settingInfo.smsCode"></el-input>
							</span>
							<el-button type="primary" plain class="ml-12 flex-1" size="medium" @click="clickSendCode" :disabled="!!sendCodeTimeText">
								{{ sendCodeTimeText ? sendCodeTimeText : sendCodeText }}
							</el-button>
						</div>
						<div class="error-msg">
							<p class="font-h6-regular yx-color-danger">{{ error.smsCode }}</p>
						</div>
					</div>
				</div>
				<!-- <div class="mt-12">
					<p class="font-h6-regular yx-color-text-secondary">
						<el-radio v-model="agreeRule" label="1"></el-radio>
						勾选即代表同意
						<span class="yx-color-text-primary cursor-pointer" @click="seeRule()">《隐私协议》</span>
					</p>
				</div> -->
				<div class="flex-row mt-6" style="height: 48px">
					<el-button type="primary" size="medium" class="flex-1" :disabled="!canLogin" @click="clickSetting" :loading="loading">
						{{ calcBtnText }}
					</el-button>
				</div>
				<div class="flex-row-align-center font-h4-regular yx-color-primary mt-16">
					<span class="font-h4-regular yx-color-text-secondary">已有账号？</span>
					<el-button type="text" @click="goLogin">登录</el-button>
				</div>
			</div>

			<div class="footer flex-row flex-align-center">
				<a
					href="https://xyt.xcc.cn/getpcInfo?sn=1498580107923533824&language=CN&certType=8&url=*.chaoyongbushou.com"
					target="_blank"
					style="position: relative"
					class="mr-20"
				>
					<div style="width: 100%; height: 100%; position: absolute; top: 0; left: 0"></div>
					<embed
						src="https://program.xinchacha.com/web/1498580107923533824=*.chaoyongbushou.com.svg"
						width="103"
						height="38"
						type="image/svg+xml"
						pluginspage="//www.adobe.com/svg/viewer/install/"
					/>
				</a>
				<a href="https://beian.miit.gov.cn/" target="_blank">备案号：{{ domainRecordNo || baseInfo.domain_record_no || '浙ICP备2022008875号' }}</a>
			</div>
		</div>
		<ChooseGroup ref="chooseGroup" :tenantInfoList="tenantInfoList" @choose="chooseGroup" :showClose="false"></ChooseGroup>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { sendRegister, loginRegister, confirmLogin } from '@/api/user';
import { accountInfo } from '@/api/common';
import { isTel } from '@/utils/reg';
import * as types from '@/store/mutation-types';
import mixin from './mixin';
import ChooseGroup from '@/components/business/chooseTenant';

export default {
	name: 'register',
	mixins: [mixin],
	components: {
		ChooseGroup,
	},
	data() {
		return {
			visible: false,
			settingInfo: {
				teamName: '',
				userName: '',
				mobile: '',
				smsCode: '',
			},
			error: {
				teamName: '',
				userName: '',
				mobile: '',
				smsCode: '',
			},
			agreeRule: '1',
			sendCodeText: '发送验证码',
			sendCodeTime: '',
			timer: null,
			loading: false,
			canLogin: false,
			linkId: '',
			tenantInfoList: [],
		};
	},
	computed: {
		...mapState(['vuex_system_conf']),
		sendCodeTimeText() {
			return this.sendCodeTime ? this.sendCodeTime + 's' : '';
		},
		checkDataStatus({ agreeRule, settingInfo }) {
			return {
				agreeRule,
				...settingInfo,
			};
		},
		calcBtnText() {
			return '注册';
		},
		domainRecordNo() {
			const hosts = location.host.split('.');
			hosts.shift();
			const domains = {
				'vipsaas.com ': 8,
			};
			const no = domains[hosts.join('.')] || '';
			return no ? `浙ICP备2021010797号-${no}` : '';
		},
	},
	watch: {
		checkDataStatus: {
			handler() {
				this.canLogin = this.validData();
			},
			deep: true,
		},
	},
	created() {
		this.linkId = this.$route.query.linkId;
	},
	methods: {
		validData() {
			if (this.agreeRule == 0) {
				return false;
			}
			if (this.settingInfo.mobile && this.settingInfo.smsCode && this.settingInfo.teamName && this.settingInfo.userName) {
				return true;
			}
			return false;
		},
		validSettingInfo() {
			if (!this.settingInfo.teamName) {
				this.error.teamName = '请输入团队名称';
			} else {
				this.error.teamName = '';
			}
			if (!this.settingInfo.userName) {
				this.error.userName = '请输入联系人名称';
			} else {
				this.error.userName = '';
			}
			if (!this.settingInfo.mobile) {
				this.error.mobile = '请输入手机号';
			} else if (!isTel.test(this.settingInfo.mobile)) {
				this.error.mobile = '手机号输入错误';
			} else {
				this.error.mobile = '';
			}
			if (!this.settingInfo.smsCode) {
				this.error.smsCode = '请输入验证码';
			} else {
				this.error.smsCode = '';
			}
			if (this.agreeRule == 0) {
				this.$message.warning('请勾选同意《隐私协议》');
				return false;
			}

			// 判断是否存在输入错误，没有错误返回true，有错误返回false
			if (this.error.mobile || this.error.smsCode || this.error.teamName || this.error.userName) {
				return false;
			}
			return true;
		},
		clickSendCode() {
			if (!this.settingInfo.mobile) {
				this.$message.error('请输入手机号');
				return;
			}
			if (!isTel.test(this.settingInfo.mobile)) {
				this.$message.error('手机号输入错误');
				return;
			}
			const params = {
				mobile: this.settingInfo.mobile,
				scene: this.vuex_system_conf.scene || 6,
			};
			sendRegister(params)
				.then(res => {
					if (res.code === 0) {
						// 短信验证码发送成功
						this.sendCodeTime = 60;
						this.startTimer();
					} else {
						this.$message.error(res.message);
					}
				})
				.catch(e => {
					this.$message.error(e.message);
				});
		},
		clearTimer() {
			clearInterval(this.timer);
			this.timer = null;
		},
		startTimer() {
			if (this.timer) {
				// 倒计时存在的时候，不要重复开启
				return;
			}
			this.timer = setInterval(() => {
				this.sendCodeTime--;
				if (this.sendCodeTime <= 0) {
					this.clearTimer();
				}
			}, 1000);
		},
		goLogin() {
			this.$router.push({
				path: '/login',
				query: {
					linkId: this.linkId,
				},
			});
		},
		async clickSetting() {
			this.loading = true;
			const valid = this.validSettingInfo();
			if (!valid) {
				this.loading = false;
				return;
			}
			let params = { ...this.settingInfo, linkId: this.linkId };
			try {
				const { accessToken, tenantInfoList } = await loginRegister(params);
				// 单租户直接登录
				if (accessToken) {
					const [{ tenantId, roleList = [], openIds = [], userId }] = tenantInfoList;
					this.handleTenantLogin({ accessToken, tenantId, roleList, openIds, userId });
				} else {
					// 没有accessToken则说明是说租户账号，展示租户列表选择登录
					this.tenantInfoList = tenantInfoList;
					this.$refs.chooseGroup.show();
				}
			} finally {
				this.loading = false;
			}
		},
		// 选择登录的租户团队
		async chooseGroup({ userId, tenantId, preAuthSign } = {}) {
			const {
				code,
				data: { accessToken, roleList, openIds },
			} = await confirmLogin({ userId, tenantId, preAuthSign });
			if (code === 0) {
				this.handleTenantLogin({ accessToken, tenantId, roleList, openIds, userId });
				this.$refs.chooseGroup.hide();
			}
		},
		seeRule() {
			window.open('https://yangxuan.feishu.cn/docs/doccnXV7qxNruNONC6j0pxzKVAb');
		},
		setData(token, tenantId, roleList, userId) {
			return new Promise(async (rs, rj) => {
				try {
					// 保存token到cookie
					CookiesTools.setToken(token);
					// 设置登录态
					this.$store.commit(types.LOGIN_STATUS, true);
					this.$store.commit(types.TENANT_ID, tenantId);
					this.$store.commit(types.USER_ID, userId);
					this.$store.commit(types.BIND_ROLES, roleList);
					const { code, data } = await accountInfo({});
					if (code == 0) {
						// 更新配置字段
						this.$store.commit(types.USER_INFO, data);
						rs();
					}
					rs();
				} catch (error) {
					rj();
				}
			});
		},
		async handleTenantLogin({ accessToken, tenantId, roleList, openIds, userId }) {
			await this.setData(accessToken, tenantId, roleList, userId);
			// 有linkId登录之后跳转回邀请商团协作页面
			// 没有绑定微信，跳转绑定微信页面
			// 没有linkId并有绑定微信跳转工作台
			if (this.linkId) {
				this.$router.replace({ path: '/invite', query: { linkId: this.linkId, isLogin: 1 } });
			} else {
				// 回到工作台页面
				this.gotoIndex(openIds);
			}
			this.loading = false;
		},
	},
};
</script>
<style scoped lang="less">
@import '@/styles/login.less';

/deep/ .el-radio {
	margin-right: 8px;
}

/deep/ .el-radio__label {
	display: none;
}

.content {
	padding: 0 36px;

	.wx-wrapper {
		img {
			margin-top: 20px;
			margin-bottom: 8px;
		}
	}

	.coupon {
		display: flex;
		flex-direction: column;
		align-items: center;

		img {
			width: 100px;
			height: 100px;
		}

		.coupon-title1 {
			font-weight: bold;
			font-size: 16px;

			.warning {
				color: @color-warning;
			}
		}
	}

	.ip-box {
		height: 136px;
		background-color: #f7f8fa;
		border-radius: 24px;
	}

	.footer-button {
		height: 96px;

		/deep/ .el-button--medium {
			border-radius: 16px;
		}
	}
}
</style>
